import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  // ===== RECEIPT (TUITION) APIs =====

  /**
   * Get student info for receipt
   */
  async getReceiptStudentInfo(params) {
    try {
      const response = await axios.get('uni/receipt/student-info', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get revenues for receipt (Tuition)
   */
  async getReceiptRevenues(params) {
    try {
      const response = await axios.get('uni/receipt/revenues', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get exemptions for receipt
   */
  async getReceiptExemptions(params) {
    try {
      const response = await axios.get('uni/receipt/exemptions', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },


  // ===== RECEIPT KTK (Khoản Thu Khác) APIs =====

  /**
   * Get KTK total revenues
   */
  async getReceiptKTKTotal(params) {
    try {
      const response = await axios.get('uni/receipt/revenuesktk-total', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get KTK revenues
   */
  async getReceiptKTKRevenues(params) {
    try {
      const response = await axios.get('uni/receipt/revenuesktk', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },


  // ===== CREATE APIs =====

  /**
   * Create a receipt (Tuition)
   */
  async createReceipt(params) {
    try {
      const response = await axios.post('uni/receipt', params)
      const { data } = response
      const isSuccessful = data.code === ApiCode.SUCCESS
      if (isSuccessful) {
        return {
          isSuccessful,
          message: data.message,
        }
      }
      return {
        isSuccessful,
        message: data.debugMessage,
      }
    } catch (e) {
      handleCatch(e)
      return {
        isSuccessful: false,
        message: 'Lỗi tạo phiếu thu',
      }
    }
  },

  /**
   * Create a receipt KTK (Khoản thu khác)
   */
  async createReceiptKTK(params) {
    try {
      const response = await axios.post('uni/receipt/create-receipt-ktk', params)
      const { data } = response
      const isSuccessful = data.code === ApiCode.SUCCESS
      if (isSuccessful) {
        return {
          isSuccessful,
          message: data.message,
        }
      }
      return {
        isSuccessful,
        message: data.debugMessage,
      }
    } catch (e) {
      handleCatch(e)
      return {
        isSuccessful: false,
        message: 'Lỗi tạo phiếu thu',
      }
    }
  },

  /**
   * Get history receipt information - Student Info
   */
  async getHistoryStudentInfo(params) {
    try {
      const response = await axios.get('uni/receipt/history-student-info', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get history receipt information - Revenues Chưa nộp (Tuition)
   */
  async getHistoryRevenuesCN(params) {
    try {
      const response = await axios.get('uni/receipt/history-revenues-cn', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get history receipt information - Revenues Đã nộp (Tuition)
   */
  async getHistoryRevenuesDN(params) {
    try {
      const response = await axios.get('uni/receipt/history-revenues-dn', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get history receipt information - Exemptions
   */
  async getHistoryExemptions(params) {
    try {
      const response = await axios.get('uni/receipt/history-exemptions', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get history receipt information - Revenues KTK Chưa nộp
   */
  async getHistoryRevenuesKTKCN(params) {
    try {
      const response = await axios.get('uni/receipt/history-revenues-ktk-cn', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },

  /**
   * Get history receipt information - Revenues KTK Đã nộp
   */
  async getHistoryRevenuesKTKDN(params) {
    try {
      const response = await axios.get('uni/receipt/history-revenues-ktk-dn', { params })
      if (response.data.code === ApiCode.SUCCESS) {
        return response.data.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
      return []
    }
  },
}
